import React from "react"

import ItemDetailsColumns from "../../../common/columns/ItemDetailsColumns"
import ItemDetailsColumn from "../../../common/columns/ItemDetailsColumn"
import EmailAddressAddWidget from "../../user-emails/edit/EmailAddressAddWidget"
import UserEditItemDetails from "./UserEditItemDetails"
import UserEditRelatedPanelWidget from "../../user-related-panel/edit/UserEditRelatedPanelWidget"

const UserEditItem = ({
    model,
    onEventChange,
    onStatusChange,
    onValueChange,
    onImageChange,
    onTopicsSearch,
    onPermissionGroupsSearch,
    onCommunitiesSearch,
}) => (
    <ItemDetailsColumns>
        <ItemDetailsColumn>
            <UserEditItemDetails
                first_name={model.first_name}
                last_name={model.last_name}
                status={model.status}
                primary_organisation={model.primary_organisation}
                primary_position={model.primary_position}
                photo_url={model.photo_url}
                bio={model.bio}
                imagePreviewURL={model.imagePreviewURL}
                onEventChange={onEventChange}
                onStatusChange={onStatusChange}
                onImageChange={onImageChange}
            />
        </ItemDetailsColumn>
        <ItemDetailsColumn>
            <EmailAddressAddWidget
                emails={model.emails}
                primary_email={model.primary_email}
                onValueChange={onValueChange}
            />
            <UserEditRelatedPanelWidget
                permission_groups={model.permission_groups}
                topics_followed={model.topics_followed}
                communities_followed={model.communities_followed}
                communities_member_of={model.communities_member_of}
                onTopicsSearch={onTopicsSearch}
                onPermissionGroupsSearch={onPermissionGroupsSearch}
                onCommunitiesSearch={onCommunitiesSearch}
                onValueChange={onValueChange}
            />
        </ItemDetailsColumn>
    </ItemDetailsColumns>
)

export default UserEditItem
